import React from 'react';

const CorporateWellnessBottomline = () => {
  const benefits = [
    {
      title: "Employee Productivity Enhancement",
      description: "Employees free from financial stress are more focused, engaged, and productive. Our programs address the root causes of financial distraction, helping your team bring their best selves to work every day."
    },
    {
      title: "Talent Acquisition & Retention",
      description: "Comprehensive financial wellness programs have become a competitive differentiator in the talent market, attracting high-quality candidates and significantly improving retention of your most valuable team members."
    },
    {
      title: "Healthcare Cost Reduction",
      description: "Financial stress is directly linked to physical health issues. Organizations implementing robust financial wellness programs report measurable reductions in healthcare utilization and associated costs."
    },
    {
      title: "Organizational Resilience",
      description: "Financially secure employees create a more stable workforce that can better weather economic uncertainties, market fluctuations, and organizational changes with reduced disruption to operations."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Corporate Financial Wellness
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CorporateWellnessBottomline;